export default {
  getToken(state) {
    return state.token;
  },
  getErrorMessage(state) {
    return state.errorMessage;
  },
  getApiURL(state) {
    return state.apiUrl;
  },
  getCurrentCoordSystem(state) {
    return state.currentCoordSystem;
  },
  getSrid(state) {
    return state.srid;
  },
  getCurrentZoom(state, ) {
    return state.zoom;
  },
  getCurrentBookmark(state) {
    return state.currentBookmark;
  },
  getModalsList(state) {
    return state.activeModals;
  },
  getBookmarks(state) {
    return state.bookmarks;
  },
  getMap(state) {
    return state.map;
  },
  getMapCenter(state) {
    return state.mapCenter;
  },
  getStartMapCenter(state) {
    return state.startMapCenter;
  },
  getAquagisName(state) {
    return state.aquagisName;
  },
  getUsername(state) {
    return state.username;
  },
  getUser(state) {
    return state.user;
  },
  getCurrentUserId(state) {
    return state.currentUserId;
  },
  getCurrentUsername(state) {
    return state.currentUsername;
  },
  getCurrentUserGroup(state) {
    return state.currentUserGroup;
  },
  getDicts(state) {
    return state.dicts;
  },
  getLayers(state) {
    // Get list of layers and their attributes
    return state.layers;
  },
  getLayersWater(state) {
    return state.layers.filter(
      x => x.layer_type === "water" /* && x.type !== "watermeters"*/
    );
  },
  getLayersSewer(state) {
    // Get list of sewer layers
    return state.layers.filter(x => x.layer_type === "sewer");
  },
  getLayer(state) {
    // Get attributes of individual layer
    return state.layer;
  },
  getAppLayers(state) {
    // " Warstwy dodatkowe "
    return state.appLayers;
  },
  getUserLayers(state) {
    // " Warstwy użytkownika "
    return state.userLayers;
  },
  getUserRasterLayers(state) {
    // " Warstwy rastrowe użytkownika"
    return state.userRasterLayers;
  },
  getTempLayers(state) {
    // " Warstwy użytkownika "
    return state.tempLayers;
  },
  getWMSLayers(state) {
    // warstwy wms
    return state.wmsLayers;
  },
  getCurrentEditedLayer(state) {
    return state.currentEditedLayer;
  },
  getLayersInstance(state) {
    return state.layersInstance;
  },
  getSnapTolerance(state) {
    return state.snapTolerance;
  },
  getSnapLayers(state) {
    return state.snapLayers;
  },
  getAppLayersMeta(state) {
    // " Warstwy dodatkowe "
    return state.appLayersMeta;
  },
  getVisibleLayers(state) {
    // Warstwy z informacją czy są widoczne (getVisible)
    return state.visibleLayers;
  },
  getBaselayers(state) {
    return state.baselayers;
  },
  getBasemapOpacity(state) {
    return state.basemapOpacity;
  },
  getCurrentBasemap(state) {
    return state.currentBasemap;
  },
  getWmtsTilegrid(state) {
    return state.wmtsTilegrid;
  },
  getWmtsTilegridGeoportal(state) {
    return state.wmtsTilegridGeoportal;
  },

  getSketches(state) {
    return state.sketches;
  },
  getLoadToMap(state) {
    return state.loadToMap;
  },
  getSocket(state) {
    return state.socket;
  },

  getStyles(state) {
    // Get MapboxGL styles of vector layers
    return state.styles;
  },
  getLabelsShow(state) {
    return state.labelsShow;
  },
  getShowDirectionFlows(state) {
    return state.showDirectionFlows;
  },
  getShowValvesState(state) {
    return state.showValvesState;
  },
  getValvesStateLegend(state) {
    return state.valvesStateLegend;
  },

  getHydrants(state) {
    return state.hydrants;
  },
  getCurrentEditedDict(state) {
    return state.currentEditedDict;
  },
  getDictForLayer(state) {
    return state.dictForLayer;
  },
  getInspectionTasks(state) {
    return state.inspectionTasks;
  },
  getSelectedHydrants(state) {
    return state.selectedHydrants;
  },
  getSelectedHydrantsEdited(state) {
    return state.selectedHydrantsEdited;
  },
  getInspectionTask(state) {
    return state.inspectionTask;
  },
  getHydrantInspectionCard(state) {
    return state.hydrantInspectionCard;
  },
  getNewFieldLayer(state) {
    return state.newFieldLayer;
  },
  getNewFieldDict(state) {
    return state.newFieldDict;
  },
  getHydrantData(state) {
    return state.hydrantData;
  },
  getInspectionCards(state) {
    return state.inspectionCards;
  },
  getMapActiveLayers(state) {
    return state.mapActiveLayers;
  },
  getMapActiveBaselayer(state) {
    return state.mapActiveBaselayer;
  },
  getTerminals(state) {
    return state.terminals;
  },
  getTerminalData(state) {
    return state.terminalData;
  },
  getCurrentSelectedFeatures(state) {
    return state.selectedFeatures;
  },
  getEditionOn(state) {
    return state.editionOn;
  },
  getTableDataActive(state) {
    return state.tableDataActive;
  },
  // folders
  getFolders(state) {
    return state.folders;
  },
  getFolderData(state) {
    return state.folderData;
  },
  getCurrentFolderArea(state) {
    return state.currentFolderArea;
  },
  // attachments
  getAttachments(state) {
    return state.attachments;
  },
  getObjectAttachments(state) {
    return state.objectAttachments;
  },
  getCurrentEditedObject(state) {
    return state.currentEditedObject;
  },
  // events
  getFeatureEvents(state) {
    return state.featureEvents;
  },
  // schedules
  getSchedules(state) {
    return state.schedules;
  },
  // tasks
  getTasks(state) {
    return state.tasks;
  },
  getTask(state) {
    return state.task;
  },
  getTask(state) {
    return state.currentTask;
  },
  getTaskMaterials(state) {
    return state.taskMaterials;
  },
  // servitudes
  getServitudes(state) {
    return state.servitudes;
  },
  getServitudeData(state) {
    return state.servitudeData;
  },
  getAnalysisResult(state) {
    return state.analysisResult;
  },
  getTransmissionEasementAdding(state) {
    return state.isTransmissionEasementAdding;
  },
  // variances
  getVariancesData(state) {
    return state.variancesList;
  },
  getVariancesStatus(state) {
    return state.variancesStatus;
  },
  getVariancesType(state) {
    return state.variancesType;
  },
  getCurrentVariance(state) {
    return state.currentVariance;
  },
  getCurrentAddingVariance(state) {
    return state.currentAddingVariance;
  },
  getCurrentVarianceArea(state) {
    return state.currentVarianceArea;
  },
  // settings
  getUsers(state) {
    return state.users;
  },
  getUsersMap(state) {
    return state.usersMap;
  },
  getEvents(state) {
    return state.events;
  },
  getEventUser(state) {
    return state.eventUser;
  },
  getSettings(state) {
    return state.settings;
  },
  // scada
  getScadaPoints(state) {
    return state.scadaPoints;
  },
  getCurrentScadaPoint(state) {
    return state.currentScadaPoint;
  },
  getScadaAlarmsLink(state) {
    return state.scadaAlarmsLink;
  },
  getScadaDmaLink(state) {
    return state.scadaDmaLink;
  },
  getScadaInterval(state) {
    return state.scadaInterval;
  },
  getScadaFeaturesArr(state) {
    return state.scadaFeaturesArr;
  },
  getLastScadaUpdate(state) {
    return state.lastScadaUpdate;
  },
  // failures
  getFailures(state) {
    return state.failures;
  },
  getCurrentFailure(state) {
    return state.currentFailure;
  },
  // Refurubishments / repairs
  getRefurbishments(state) {
    return state.refurbishments;
  },
  getCurrentRefurbishment(state) {
    return state.currentRefurbishment;
  },
  // Costs
  getFailureCosts(state) {
    return state.failureCosts;
  },
  getRefurbishmentCosts(state) {
    return state.refurbishmentCosts;
  },
  getTaskCosts(state) {
    return state.taskCosts;
  },
  // Video
  getVideoInspectionCards(state) {
    return state.videoInspectionCards;
  },
  getVideoInspectionCard(state) {
    return state.videoInspectionCard;
  },
  getCurrentVideo(state) {
    return state.currentVideo
  },

  getGenerateID(state) {
    return state.generateID;
  },

  // Modelowanie wodociągowe modelWat
  getIncludedReceiver(state) {
    return state.includeReceiver
  },
  getModelWatDisplaySettings(state) {
    return state.modelWatDisplaySettings;
  },
  getModelWatTimeStep(state) {
    return state.modelWatTimeStep;
  },

  getVirtualRecipients(state) {
    return state.virtualRecipients;
  },
  getVirtualRecipient(state) {
    return state.virtualRecipient;
  },
  //Hydranet
  getHydraNetWatermeters(state) {
    return state.hydraNetWatermeters;
  },
  getHydranetUrl(state) {
    return state.hydranetUrl;
  },
  // Wodomierze
  getWatermeters(state) {
    return state.watermeters;
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js